import { normalizeLocale, type SupportedLocale } from '../i18n';
import type { SupabaseClient } from '../supabase/client';

interface AdminPreferredLocaleRow {
  preferred_locale: string;
}

export interface SetAdminPreferredLocaleInput {
  preferredLocale: SupportedLocale;
}

export async function getAdminPreferredLocale(
  client: SupabaseClient,
): Promise<SupportedLocale | null> {
  const { data, error } = await client
    .from('merchant_profiles')
    .select('preferred_locale')
    .is('deleted_at', null)
    .maybeSingle<AdminPreferredLocaleRow>();

  if (error) throw error;
  return data ? normalizeLocale(data.preferred_locale) : null;
}

export async function setAdminPreferredLocale(
  client: SupabaseClient,
  input: SetAdminPreferredLocaleInput,
): Promise<SupportedLocale> {
  const { data, error } = await client.rpc('set_merchant_preferred_locale', {
    profile_preferred_locale: input.preferredLocale,
  });

  if (error) throw error;
  if (!data) throw new Error('setAdminPreferredLocale: RPC returned no merchant profile');

  return normalizeLocale(data.preferred_locale);
}
